import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"

const DEFAULT_DIALOG_CONTENT = {
  debtId: null,
  paymentSchedule: null,
  paymentScheduleId: null,
  subscription: null,
  subscriptionId: null,
  productId: null,
  plan: null,
  amount: null,
}

const dialogAdapter = createEntityAdapter()
export const initialState = dialogAdapter.getInitialState({
  type: null,
  step: 0,
  dialogContent: DEFAULT_DIALOG_CONTENT,
})

export const dialogSlice = createSlice({
  name: "dialog",
  initialState,
  reducers: {
    openDialog: (state, { payload }) => {
      state.type = payload.type

      const { content } = payload

      if (content) {
        state.dialogContent = content
      }
    },
    updateDialog: (state, { payload }) => {
      state.dialogContent = {
        ...state.dialogContent,
        ...payload.content,
      }
    },
    updateDialogStep: (state, { payload }) => {
      state.step = payload.step
    },
    closeDialog: (state) => {
      state.type = null
    },
  },
})

export const selectType = (state: RootState) => state.features.dialog.type
export const selectStep = (state: RootState) => state.features.dialog.step
export const selectContent = (state: RootState) =>
  state.features.dialog.dialogContent

export const { openDialog, updateDialog, updateDialogStep, closeDialog } =
  dialogSlice.actions
export default dialogSlice.reducer
